import { useCallback, useEffect, useState } from "react";
import axiosInstance from "config/axiosInstance";
import { normalizePhone } from "utils/phone";

function buildFromSecundarios(usuarios) {
  const destinatarios = [];

  for (const u of usuarios) {
    if (u.activo === 0 || u.activo === false) {
      continue;
    }
    const numero = normalizePhone(u.celular);
    if (!numero) {
      continue;
    }
    destinatarios.push({
      numero,
      label: (u.nombre || "").trim() || null,
      origen: "usuarios_secundarios",
      usuario_secundario_id: u.id,
    });
  }

  return {
    origen: destinatarios.length ? "usuarios_secundarios" : null,
    numeros: destinatarios.map((d) => d.numero),
    count: destinatarios.length,
    destinatarios,
    rebote_count: 0,
    secundarios_count: destinatarios.length,
    sin_rebote: true,
    from_catalog_fallback: true,
  };
}

export default function useWhatsAppRecipients({ enabled = true, refreshKey = 0 } = {}) {
  const [recipients, setRecipients] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!enabled) {
      return;
    }

    setLoading(true);
    try {
      const res = await axiosInstance.get("/whatsapp/recipients");
      const apiRecipients = res.data?.notificationRecipients;
      if (res.data?.success && apiRecipients?.count > 0) {
        setRecipients(apiRecipients);
        return;
      }
    } catch {
      // fallback abajo
    }

    try {
      const secRes = await axiosInstance.get("/secondary-users");
      if (secRes.data?.success) {
        setRecipients(buildFromSecundarios(secRes.data.usuarios || []));
        return;
      }
    } catch {
      // sin datos
    }

    setRecipients({
      origen: null,
      numeros: [],
      count: 0,
      destinatarios: [],
      rebote_count: 0,
      secundarios_count: 0,
    });
  }, [enabled]);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return { recipients, loading, reload: load };
}
